import SwitchButton from "components/SwitchButton";
import React, { useState } from "react";
import "./index.scss";
import { Collapse } from "reactstrap";
import api from "api";
import { normalizeBrandLocationType } from "pages/Map/helper/NormalizeLocationData";
import images from "common/images";
import { MapData } from "pages/Map";
import t from "utils/Lang";

type MenuDisplayProps = {
  selectedLocationType: Array<number>;
  selectedBrand: Array<number>;
  onChange: (
    selectedLocationType: Array<number>,
    selectedBrand: Array<number>
  ) => void;
  nearbyLocationSummary: MapData;
  getNewBrand: (brand: any) => void;
  brandObj: { [key: string]: any };
};

const MenuDisplay = ({
  nearbyLocationSummary,
  onChange,
  selectedBrand,
  selectedLocationType,
  getNewBrand,
  brandObj,
}: MenuDisplayProps) => {
  const onLocSwitched = (loc: any) => async (checked: boolean) => {
    const newSelectedLocationType = checked
      ? [...selectedLocationType, loc.location_type_id]
      : selectedLocationType.filter((id) => id != loc.location_type_id);
    let newSelectedBrand = selectedBrand;
    const currentBrands = brandObj[`${loc.location_type_id}`];
    if (checked) {
      if (!brandObj[`${loc.location_type_id}`]) {
        const res = await api.brandLocationType(loc.location_type_id);
        getNewBrand({
          [`${loc.location_type_id}`]: normalizeBrandLocationType(res),
        });
        newSelectedBrand = [
          ...selectedBrand,
          ...normalizeBrandLocationType(res).map((dt: any) => dt.id),
        ];
      } else {
        newSelectedBrand = [
          ...selectedBrand,
          ...brandObj[`${loc.location_type_id}`].map((dt: any) => dt.id),
        ];
      }
    } else {
      const compareBrands = currentBrands || [];
      newSelectedBrand = newSelectedBrand.filter(
        (br: any) => !compareBrands.find((cbr: any) => cbr.id == br)
      );
    }
    const uniqSelectedBrand: any = new Set(newSelectedBrand);
    onChange(newSelectedLocationType, [...uniqSelectedBrand]);
  };
  const toggleBrand = (brand: any, isChecked: boolean) => () => {
    const newSelectedBrand = isChecked
      ? selectedBrand.filter((br) => br != brand.id)
      : [...selectedBrand, brand.id];
    onChange(selectedLocationType, newSelectedBrand);
  };
  const renderBrand = (brand: any) => {
    const isChecked = !!selectedBrand.find((id) => id == brand.id);
    return (
      <div
        key={brand.id}
        className="menu-display__subcategory-item normal-button"
        onClick={toggleBrand(brand, isChecked)}
      >
        <i className="material-icons eye-icon">
          {isChecked ? "visibility" : "visibility_off"}
        </i>
        <span className="subcategory-item__name">{brand.name}</span>
      </div>
    );
  };
  const renderLocationSummary = (loc: any) => {
    const isChecked = !!selectedLocationType.find(
      (id) => id == loc.location_type_id
    );
    const brands = brandObj?.[`${loc.location_type_id}`] || [];
    return (
      <div className="menu-display__category-item" key={loc.location_type_id}>
        <div className="menu-display__main-category">
          <img
            className="category-item__logo"
            src={loc.location_map_icon || images.defaultCategory}
          />
          <span className="category-item__name">{loc.location_type_name}</span>
          <SwitchButton checked={isChecked} onChange={onLocSwitched(loc)} />
        </div>
        {brands.length > 0 && (
          <Collapse isOpen={isChecked} style={{ marginBottom: 7 }}>
            <div>{brands.map(renderBrand)}</div>
          </Collapse>
        )}
        <div className="category-item__separate-line" />
      </div>
    );
  };
  const toggleOff = () => onChange([], []);
  return (
    <div className="menu-display__container">
      <div
        className={`site-planning__sidebar-data-widget-is-loading-data ${
          nearbyLocationSummary?.loading ? "active" : ""
        }`}
      />
      <span className="menu-display__reset normal-button" onClick={toggleOff}>
        {t().map__hide_all}
      </span>
      {nearbyLocationSummary?.data?.map?.(renderLocationSummary)}
    </div>
  );
};

export default MenuDisplay;
